export class BodyNoScroll {
  static Enable = () => {
    document.body.classList.add("overflow-y-hidden");
  };
  static Disable = () => {
    document.body.classList.remove("overflow-y-hidden");
  };
}
